import React from 'react'
import { translate } from '../../utils/useful'
import { withRouter } from 'react-router-dom'
import { pathMaker } from '../../utils/useful'
import { siteTheme } from '../../variables/config'

const colors = siteTheme.primaryColors

class SignUpSuccessStep extends React.Component {
    state = {
        timer: 3,
    }

    componentDidMount() {
        this.timer = setInterval(this.checkTimer, 1000);
    }

    componentWillUnmount() {
        if (this.timer) clearInterval(this.timer)
    }

    checkTimer = () => {
        if (this.state.timer > 0) {
            this.setState({ timer: this.state.timer - 1 })
        } else {
            this.props.history.push(pathMaker('/login'))
        }
    }

    goToLogin = () => {
        this.props.history.push(pathMaker('/login'))
    }

    goBack = () => {
        if (this.props.stageManager) {
            this.props.stageManager.lastStage()
        }
    }

    render() {
        return (
            <div className="flexcc flex-column">
                <div className="w-100 mt-2 text-center" style={{ maxWidth: 400 }}>
                    <div style={{
                        width: 80,
                        height: 80,
                        borderRadius: '50%',
                        background: `linear-gradient(135deg, ${colors.main1}, ${colors.main2})`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 20px',
                        boxShadow: `0 8px 25px ${colors.main1}40`
                    }}>
                        <img src="/images/icons/success.svg" width="50px" style={{ filter: 'invert(1)' }} />
                    </div>
                    <h2 className="mt-3 mb-2" style={{ fontSize: 27, whiteSpace: 'nowrap', color: colors.main1 }}>
                        {translate('Registration Successful').toUpperCase()}
                    </h2>
                    <p className="mb-2 mt-2" style={{ fontSize: 15, color: '#789' }}>
                        {translate('Your account has been created successfully')}
                    </p>
                    <p className="mb-4 mt-0" style={{ fontSize: 15, color: '#789' }}>
                        {translate('Redirecting to login page in')} {this.state.timer} {translate('seconds')}...
                    </p>
                    <div className="d-flex gap-3 justify-content-center align-items-center" style={{ flexWrap: 'wrap' }}>
                        <button 
                            onClick={this.goBack}
                            style={{ 
                                background: `linear-gradient(135deg, ${colors.main3}20, ${colors.main3}30)`,
                                border: `2px solid ${colors.main3}80`,
                                borderRadius: 50,
                                color: colors.main1,
                                padding: '12px 35px',
                                fontSize: 15,
                                fontWeight: 600,
                                cursor: 'pointer',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                boxShadow: `0 2px 8px ${colors.main3}30`,
                                minWidth: 120,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 8
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = `linear-gradient(135deg, ${colors.main3}35, ${colors.main3}45)`
                                e.currentTarget.style.borderColor = colors.main3
                                e.currentTarget.style.transform = 'translateY(-2px)'
                                e.currentTarget.style.boxShadow = `0 4px 12px ${colors.main3}40`
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = `linear-gradient(135deg, ${colors.main3}20, ${colors.main3}30)`
                                e.currentTarget.style.borderColor = colors.main3 + '80'
                                e.currentTarget.style.transform = 'translateY(0)'
                                e.currentTarget.style.boxShadow = `0 2px 8px ${colors.main3}30`
                            }}
                        >
                            <span>←</span> {translate('Back')}
                        </button>
                        <button 
                            onClick={this.goToLogin}
                            style={{ 
                                background: `linear-gradient(135deg, ${colors.main1} 0%, ${colors.main1} 75%, ${colors.main2} 100%)`,
                                borderRadius: 50,
                                border: 'none',
                                color: '#fff',
                                padding: '12px 35px',
                                fontSize: 15,
                                fontWeight: 600,
                                cursor: 'pointer',
                                boxShadow: `0 4px 20px ${colors.main1}40, 0 2px 8px ${colors.main1}20`,
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                minWidth: 140,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)'
                                e.currentTarget.style.boxShadow = `0 6px 25px ${colors.main1}50, 0 3px 10px ${colors.main1}30`
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)'
                                e.currentTarget.style.boxShadow = `0 4px 20px ${colors.main1}40, 0 2px 8px ${colors.main1}20`
                            }}
                        >
                            {translate('Go to Login')}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(SignUpSuccessStep)

